// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UserService } from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Service/User';
import { ERR_REV_CAN_CRED, SUC_REV_CAN_CRED } from '../../../utils/strings';
import { useExerciseSubmission } from '../ledger/useSubmission';

const useRevokeCredentialAndCancelBilling = () => {
  const { submit } = useExerciseSubmission(
    UserService.UserService_RevokeCredentialAndCancelBilling,
    SUC_REV_CAN_CRED,
    ERR_REV_CAN_CRED,
  );

  return submit;
};

export default useRevokeCredentialAndCancelBilling;
